import styled from '@emotion/styled'
import { Dispatch, SetStateAction } from 'react'
import { useForm } from 'react-hook-form'

const Input = styled.input`
  padding-inline-start: 0;
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  font-size: 14px;
  width: 110px;
  height: 40px;
  border-radius: 10px;
  color: #707070;
  text-align: center;
  background-color: transparent;
  border: 1px solid #707070;
`

export function DatePicker({
  name,
  setDate,
}: {
  name: string
  setDate: Dispatch<SetStateAction<number>>
}) {
  const { register, handleSubmit } = useForm()
  const onSubmit = (data: Record<string, string>) => {
    const [year, month, day] = data[name].split('-')
    setDate(Date.UTC(parseInt(year), parseInt(month) - 1, parseInt(day)))
  }
  return (
    <form onChange={handleSubmit(onSubmit)}>
      <Input type="date" placeholder="dd/mm/yyyy" {...register(name)} />
    </form>
  )
}

export function DatePickerInclusive({
  name,
  setDate,
  min,
}: {
  name: string
  setDate: Dispatch<SetStateAction<number>>
  min: string
}) {
  const { register, handleSubmit } = useForm()
  const onSubmit = (data: Record<string, string>) => {
    const [year, month, day] = data[name].split('-')
    const date =
      Date.UTC(parseInt(year), parseInt(month) - 1, parseInt(day)) + 86400000
    setDate(date)
  }
  return (
    <form onChange={handleSubmit(onSubmit)}>
      <Input
        type="date"
        placeholder="dd/mm/yyyy"
        {...register(name)}
        min={min}
      />
    </form>
  )
}
